import { Td, Tr } from "../../SetiTable.styled";
import { CRITICAL_COLOR, WARN_COLOR } from "../ReportElements";
import React from "react";

export function FooterRows({
  isPreHawkeye,
  year,
  canCreateIncident,
  groupsToShow,
  infoColumnCount,
  showPitchesAsCount = false,
  showBipAsCount = false,
  showSwingsAsCount = false,
}) {
  //optical column only shows pre Hawkeye
  let opticalWarn;
  let opticalAlert;
  if (isPreHawkeye) {
    opticalWarn = <Td bgcolor={WARN_COLOR}>97% to 98% {year}</Td>;
    opticalAlert = <Td bgcolor={CRITICAL_COLOR}>{"< 97%"}</Td>;
  }
  let bipWarn;
  let bipAlert;
  if (isPreHawkeye) {
    bipWarn = "80% to 90%";
    bipAlert = "< 80%";
  } else {
    bipWarn = "95% to 99.999%";
    bipAlert = "<95%";
  }
  const baseInfoCols = infoColumnCount || (canCreateIncident ? 5 : 4);
  const numColumns = getNumColumns(baseInfoCols, groupsToShow, isPreHawkeye);

  const videoColSpan = 10 + (groupsToShow.showReviewAngles ? 2 : 0);

  return (
    <>
      <Tr>
        <td colSpan={numColumns}>&#8203;</td>
      </Tr>
      <Tr>
        {Array.from({ length: baseInfoCols }).map((_, i) => (
          <Td key={i} noborder />
        ))}
        {groupsToShow.showPitches && (
          <>
            {showPitchesAsCount ? (
              <Td noborder />
            ) : (
              <Td bgcolor={WARN_COLOR}>99% to 99.5%</Td>
            )}
            {opticalWarn}
            <Td bgcolor={WARN_COLOR}>90% to 95%</Td>
            <Td bgcolor={WARN_COLOR}>0.1% to 1%</Td>
          </>
        )}
        {groupsToShow.showVideo && (
          <Td bgcolor={WARN_COLOR} colSpan={videoColSpan}>
            99.5% to 99.9999%
          </Td>
        )}
        {groupsToShow.showHitting && (
          <>
            {showBipAsCount ? (
              <Td noborder />
            ) : (
              <Td bgcolor={WARN_COLOR}>{bipWarn}</Td>
            )}
            {showSwingsAsCount ? (
              <Td noborder />
            ) : (
              <Td bgcolor={WARN_COLOR}>90% to 95%</Td>
            )}
          </>
        )}
        {groupsToShow.showPlayers && (
          <>
            <Td bgcolor={WARN_COLOR} colSpan={4}>
              90% to 95%
            </Td>
          </>
        )}
      </Tr>
      <Tr>
        {Array.from({ length: baseInfoCols }).map((_, i) => (
          <Td key={i} noborder />
        ))}
        {groupsToShow.showPitches && (
          <>
            {showPitchesAsCount ? (
              <Td noborder />
            ) : (
              <Td bgcolor={CRITICAL_COLOR}>{"< 99%"}</Td>
            )}
            {opticalAlert}
            <Td bgcolor={CRITICAL_COLOR}>{"< 90%"}</Td>
            <Td bgcolor={CRITICAL_COLOR}>{"> 1%"}</Td>
          </>
        )}
        {groupsToShow.showVideo && (
          <Td bgcolor={CRITICAL_COLOR} colSpan={videoColSpan}>
            {"< 99.5%"}
          </Td>
        )}
        {groupsToShow.showHitting && (
          <>
            {showBipAsCount ? (
              <Td noborder />
            ) : (
              <Td bgcolor={CRITICAL_COLOR}>{bipAlert}</Td>
            )}
            {showSwingsAsCount ? (
              <Td noborder />
            ) : (
              <Td bgcolor={CRITICAL_COLOR}>{"< 90%"}</Td>
            )}
          </>
        )}
        {groupsToShow.showPlayers && (
          <>
            <Td bgcolor={CRITICAL_COLOR} colSpan={4}>
              {"< 90%"}
            </Td>
          </>
        )}
      </Tr>
    </>
  );
}

function getNumColumns(baseInfoCols, groupsToShow, isPreHawkeye) {
  let numColumns = baseInfoCols;
  numColumns += groupsToShow.showPitches ? (isPreHawkeye ? 4 : 3) : 0;
  numColumns += groupsToShow.showVideo
    ? 10 + (groupsToShow.showReviewAngles ? 2 : 0)
    : 0;
  numColumns += groupsToShow.showHitting ? 2 : 0;
  numColumns += groupsToShow.showPlayers ? 2 : 0;
  return numColumns;
}
